<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Author List</h4>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow class="author-list-toolbar">
            <CCol md="6" lg="7" class="author-list-toolbar__create">
              <CButton
                  color="primary"
                  class="float-left mb-2"
                  @click="corporateAuthorActionCreate"
              >Create</CButton
              >
            </CCol>
            <CCol md="3" lg="2" class="author-list-toolbar__language">
              <LanguageRadioGroup
                  v-model="request.language"
                  name="cms-corporate-author-list-language"
                  id-prefix="cms-corporate-author-list-language"
                  test-id="cms-corporate-author-list-language"
                  :disabled="isLoading"
                  @change="onLanguageChange"
              />
            </CCol>
            <CCol md="3" lg="3" class="author-list-toolbar__search">
              <CInput
                  class="author-list-search"
                  placeholder="Search By Name or Slug"
                  data-testid="cms-corporate-author-list-search"
                  v-model="request.author_name"
                  @input="onSearch()"
              >
                <template #prepend-content>
                  <CIcon name="cil-magnifying-glass" />
                </template>
              </CInput>
            </CCol>
          </CRow>
          <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="100"
              clickable-rows
              :active-page="1"
              :pagination="false"
              data-testid="cms-corporate-author-list-table"
              @page-change="pageChange"
          >
            <template #corporate_action_ids="data">
              <td>
                <div class="button-table">
                  <CButton
                      color="primary"
                      class="mb-0 mr-0"
                      @click="rowClicked(data.item.author_id)"
                  >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
                class="pagination-btn-refresh"
                data-testid="cms-corporate-author-list-refresh"
                @click="handlePagination('REFRESH')"
            >
              Refresh
            </div>
            <div
                class="pagination-btn-back"
                data-testid="cms-corporate-author-list-back"
                @click="handlePagination('BACK')"
            >
              back
            </div>
            <div
                class="pagination-page-title"
                data-testid="cms-corporate-author-list-page"
            >{{ request.page }}</div>
            <div
                class="pagination-btn-next"
                data-testid="cms-corporate-author-list-next"
                @click="handlePagination('NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import jwt from "jsonwebtoken";
import {TimeMapper} from "../../../app/helper/timeMapper";
import CorporateAuthorUseCase from "./app/usecase";
import LanguageRadioGroup from "../../../components/LanguageRadioGroup.vue";
import { DEFAULT_AUTHOR_LANGUAGE } from "./app/types";

export default {
  name: "corporate",
  components: { LanguageRadioGroup },
  data() {
    return {
      items: [],
      fields: [
        { key: "author_id", label: "ID" },
        { key: "author_name", label: "Name" },
        { key: "author_slug", label: "Slug" },
        { key: "author_status", label: "Status" },
        { key: "corporate_action_ids", label: "Action" },
      ],
      token: "Bearer " + localStorage.getItem("token"),
      request: {
        page: 1,
        per_page: 20,
        author_name: "",
        language: DEFAULT_AUTHOR_LANGUAGE,
      },
      isLoading: false,
      loadError: null,
      searchTimeout: null,
      requestSequence: 0,
      optionsArticleInfo: [
        { label: "All", value: "" },
        { label: "MITRA", value: "MITRA" },
        { label: "SELLER", value: "SELLER" },
        { label: "BLOG MALAYSIA", value: "BLOG_MALAYSIA" }
      ],
      optionsStatus: [
        { label: 'All', value: '' },
        { label: 'ACTIVE', value: 'TRUE' },
        { label: 'INACTIVE', value: 'FALSE' },
      ]
    };
  },
  mounted() {
    this.authentication();
    this.loadAuthors(1);
  },
  beforeDestroy() {
    clearTimeout(this.searchTimeout);
    this.requestSequence += 1;
  },
  methods: {
    handleArticleInfo(event) {
      this.request.article_info = event.target.value;
      this.onSearch();
    },
    handleStatus(event) {
      this.request.s = event.target.value;
      this.onSearch();
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    onLanguageChange(language) {
      clearTimeout(this.searchTimeout);
      this.request.language = language;
      this.loadAuthors(1);
    },
    onSearch() {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => this.loadAuthors(1), 500);
    },
    /**
     * @param {number} targetPage
     */
    async loadAuthors(targetPage) {
      const currentPage = this.request.page;
      const sequence = ++this.requestSequence;
      this.isLoading = true;
      this.loadError = null;

      const query = {
        page: targetPage,
        per_page: this.request.per_page,
        author_name: this.request.author_name,
        language: this.request.language,
      };

      const { data, err } = await CorporateAuthorUseCase.getAll(query);

      if (sequence !== this.requestSequence) {
        return;
      }
      this.isLoading = false;

      if (err) {
        this.loadError = err;
        await this.$swal.fire({
          icon: "error",
          text: err,
        });
        return;
      }

      const items = data || [];
      if (items.length === 0 && targetPage > currentPage) {
        return;
      }

      window.scrollTo(0, 0);
      items.forEach((element) => {
        element.active_date = TimeMapper.SetFormatDate(element.active_date, false, ["/", "/", ":"], true, true)
      });
      this.items = items.map((obj) => {
        return {
          ...obj,
           author_status: this.optionsStatus.find(options => options.value === obj.author_status) || obj.author_status
        }
      });
      this.request.page = targetPage;
    },
    handlePagination(action) {
      clearTimeout(this.searchTimeout);
      let targetPage = this.request.page;
      if (action === "NEXT") {
        targetPage = this.request.page + 1;
      } else if (action === "BACK") {
        targetPage = Math.max(1, this.request.page - 1);
      } else if (action === "REFRESH") {
        targetPage = 1;
      }
      this.loadAuthors(targetPage);
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/corporate-author/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    corporateAuthorActionCreate() {
      this.$router.push({ path: `/management/corporate-author/create` });
    },
  },
};
</script>

<style scoped>
@import url("./CorporateAuthor.css");

.author-list-toolbar {
  align-items: flex-end;
  margin-bottom: 1rem;
}

.author-list-toolbar__create {
  padding-bottom: 0.25rem;
}

.author-list-toolbar__search {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.author-list-search {
  width: 100%;
}

@media (max-width: 767.98px) {
  .author-list-toolbar__search {
    justify-content: flex-start;
    margin-top: 1rem;
  }

  .author-list-toolbar__create {
    padding-bottom: 0;
  }
}
</style>
